export const chatKitSessionBody = {
  expiresAfter: 333,
  maxRequestsPerMinute: 99,
  chatkitConfiguration: {
    automaticThreadTitlingEnabled: true,
    fileUpload: {
      enabled: false,
    },
    history: {
      enabled: true,
      recentThreads: 10,
    },
  },
}
